import React, {Fragment} from 'react';
import { Helmet } from 'react-helmet';

import OurPaystubs from "../../components/Paystubs";
import Footer from "../../components/Footer";
import BreadCrumb from "../../components/BreadCrumb";
import WhoWeAre from "../../components/WhoWeAre";
import Method from "../../components/Method";
import CTA from "../../components/CTA"
import Remittance from '../../components/Remittance';

const Paystubs = () => {
    return(
        <Fragment>
            <Helmet>
                <title>One Two Pay Our Paystubs</title>
                <meta name="description" content="Todos!" />
            </Helmet>
            <BreadCrumb
                title="One Two Pay"
                pagename="About us"
            />
            <WhoWeAre/>
            <OurPaystubs/>
            <Remittance/>
            <Method/>
            <CTA/>
            <Footer/>
        </Fragment>
    )
};

export default Paystubs;